import React from "react";
import { useCrumbs } from "../component/breadcrumbs";
import { Helmet } from "react-helmet-async";
import useLocale from "../util/i18n";
import { usePayload, useRbac } from "../util/token";
import Dispatch from "./stock/Dispatch";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { type StatData, getCreditMemoStatuses, getPurchaseOrderStatuses, getSalesOrderStatuses, getShipmentStatuses, statCreditMemos, statSalesOrders } from "../api/erp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faSpinner } from "@fortawesome/free-solid-svg-icons";
import EChartsReact from "echarts-for-react";
import * as echarts from "echarts/core";
import { PieChart, BarChart } from "echarts/charts";
import { TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components';
import { SVGRenderer } from "echarts/renderers";
import { getLogs, getLogsStat, getUser } from "../api/admin";
import Select, { type OptionType } from "../component/select";
import { getUnixTime, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subYears } from "date-fns";
import BigNumber from "bignumber.js";

echarts.use([PieChart, BarChart, SVGRenderer, TooltipComponent, TitleComponent, LegendComponent]);

export default function Dashboard() {
    let { 0: orders, 1: setOrders } = React.useState<any>(null);
    let { 0: shipments, 1: setShipments } = React.useState<any>(null);
    let { 0: purchaseOrders, 1: setPurchaseOrders } = React.useState<any>(null);
    let { 0: creditMemos, 1: setCreditMemos } = React.useState<any>(null);
    let { 0: isGranted } = useRbac();
    let { 0: __ } = useLocale();
    let { 0: setCrumbs } = useCrumbs();
    let { 0: payload } = usePayload();
    let load = React.useCallback((force = false) => {
        isGranted('__sales_order_status__GET') && getSalesOrderStatuses(force).then(response => {
            if (typeof response !== 'string') {
                let config: any = { tooltip: { trigger: 'item' }, legend: { orient: 'horizontal', left: 'center', top: 'bottom' }, series: [{ name: '', type: 'pie', radius: '50%', data: [], label: { formatter: '{b}: {@2012} ({d}%)' }, emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } } }] };
                for (let i of response) {
                    config.series[0].data.push({ value: i.count, name: i.status });
                }
                setOrders(config);
            }
        });
        isGranted('__sales_shipment_status__GET') && getShipmentStatuses(force).then(response => {
            if (typeof response !== 'string') {
                let config: any = { tooltip: { trigger: 'item' }, legend: { orient: 'horizontal', left: 'center', top: 'bottom' }, series: [{ name: '', type: 'pie', radius: '50%', data: [], label: { formatter: '{b}: {@2012} ({d}%)' }, emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } } }] };
                for (let i of response) {
                    config.series[0].data.push({ value: i.count, name: i.status });
                }
                setShipments(config);
            }
        });
        isGranted('__purchase_order_status__GET') && getPurchaseOrderStatuses(force).then(response => {
            if (typeof response !== 'string') {
                let config: any = { tooltip: { trigger: 'item' }, legend: { orient: 'horizontal', left: 'center', top: 'bottom' }, series: [{ name: '', type: 'pie', radius: '50%', data: [], label: { formatter: '{b}: {@2012} ({d}%)' }, emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } } }] };
                for (let i of response) {
                    config.series[0].data.push({ value: i.count, name: i.status });
                }
                setPurchaseOrders(config);
            }
        });
        isGranted('__credit_memo_status__GET') && getCreditMemoStatuses(force).then(response => {
            if (typeof response !== 'string') {
                let config: any = { tooltip: { trigger: 'item' }, legend: { orient: 'horizontal', left: 'center', top: 'bottom' }, series: [{ name: '', type: 'pie', radius: '50%', data: [], label: { formatter: '{b}: {@2012} ({d}%)' }, emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } } }] };
                for (let i of response) {
                    config.series[0].data.push({ value: i.count, name: i.status });
                }
                setCreditMemos(config);
            }
        });
    }, [__, isGranted]);
    const sales = React.useRef<() => void>(null);
    const points = React.useRef<() => void>(null);
    const counts = React.useRef<() => void>(null);
    const claims = React.useRef<() => void>(null);
    let reload = React.useCallback(() => {
        load(true);
        sales.current?.();
        points.current?.();
        counts.current?.();
        claims.current?.();
    }, [load]);
    React.useEffect(load, [load]);
    React.useEffect(() => {
        setCrumbs(['Dashboard']);
    }, [setCrumbs]);
    return payload?.admin == 3 ? (
        <Dispatch />
    ) : (
        <>
            <Helmet prioritizeSeoTags>
                <title>{__('Dashboard')}</title>
            </Helmet>
            <MDBContainer fluid>
                <MDBBtn onClick={reload} color="white" className="position-fixed" style={{ right: 0, bottom: '25%', zIndex: 20000, boxShadow: '0 0 7px rgba(0,0,0,.15)' }}>
                    <FontAwesomeIcon icon={faArrowsRotate} />
                </MDBBtn>
                <MDBRow className="g-3">
                    {/*isGranted('__sales_order_status__GET') ? (
                        <MDBCol size={12} md={6} lg={3}>
                            <MDBCard>
                                <MDBCardHeader>{__('Orders')}</MDBCardHeader>
                                <MDBCardBody>
                                    {orders ? (
                                        <EChartsReact
                                            echarts={echarts}
                                            option={orders}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                                    )}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ) : null}
                    {isGranted('__sales_shipment_status__GET') ? (
                        <MDBCol size={12} md={6} lg={3}>
                            <MDBCard>
                                <MDBCardHeader>{__('Shipments')}</MDBCardHeader>
                                <MDBCardBody>
                                    {shipments ? (
                                        <EChartsReact
                                            echarts={echarts}
                                            option={shipments}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                                    )}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ) : null}
                    {isGranted('__purchase_order_status__GET') ? (
                        <MDBCol size={12} md={6} lg={3}>
                            <MDBCard>
                                <MDBCardHeader>{__('Purchase Orders')}</MDBCardHeader>
                                <MDBCardBody>
                                    {purchaseOrders ? (
                                        <EChartsReact
                                            echarts={echarts}
                                            option={purchaseOrders}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                                    )}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ) : null}
                    {isGranted('__credit_memo_status__GET') ? (
                        <MDBCol size={12} md={6} lg={3}>
                            <MDBCard>
                                <MDBCardHeader>{__('Credit Memos')}</MDBCardHeader>
                                <MDBCardBody>
                                    {creditMemos ? (
                                        <EChartsReact
                                            echarts={echarts}
                                            option={creditMemos}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                                    )}
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ) : null*/}
                    {isGranted('__admin_kpi__GET') ? (
                        <>
                            <MDBCol size={12}>
                                <MDBCard>
                                    <MDBCardHeader>{__('Assembly Count')}</MDBCardHeader>
                                    <MDBCardBody>
                                        <Counts ref={counts} type="1" />
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol size={12}>
                                <MDBCard>
                                    <MDBCardHeader>{__('Assembly KPI')}</MDBCardHeader>
                                    <MDBCardBody>
                                        <Points ref={points} type="1" />
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol size={12}>
                                <MDBCard>
                                    <MDBCardHeader>{__('Assembly Damage Rate')}</MDBCardHeader>
                                    <MDBCardBody>
                                        <Claims ref={claims} type="1" />
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol size={12}>
                                <MDBCard>
                                    <MDBCardHeader>{__('Bonus')}</MDBCardHeader>
                                    <MDBCardBody>
                                        <Points ref={points} type="-1" />
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol size={12}>
                                <MDBCard>
                                    <MDBCardHeader>{__('Organize KPI')}</MDBCardHeader>
                                    <MDBCardBody>
                                        <Points ref={points} type="2" />
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                        </>
                    ) : null}
                    {/*isGranted('__sales_order_stat__GET') || isGranted('__credit_memo_stat__GET') ? (
                        <MDBCol size={12}>
                            <MDBCard>
                                <MDBCardBody>
                                    <Sales ref={sales} />
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ) : null*/}
                </MDBRow>
            </MDBContainer>
        </>
    );
};

const Points = React.forwardRef<() => void, { type: string }>(function ({ type }, ref) {
    let { 0: points, 1: setPoints } = React.useState<any>(null);
    let { 0: user, 1: setUser } = React.useState<string>('');
    let { 0: mode, 1: setMode } = React.useState<string>('m');
    let { 0: users, 1: setUsers } = React.useState<Array<OptionType>>([]);
    let { 0: __ } = useLocale();
    let { 0: isGranted } = useRbac();
    React.useEffect(() => {
        let permissions = type == '1' ? 'claimKPI' : (type == '2' ? 'setStockStatus' : undefined);
        isGranted('__admin_user__GET') && getUser({ filter: { status: { gte: 0 }, permissions }, limit: -1 } as any).then(response => {
            if (typeof response !== 'string') {
                let options = [];
                for (let item of response.data) {
                    options.push({ value: item.id.toString(), label: item.info?.nickname || item.username });
                }
                setUsers(options);
            }
        });
    }, [setUsers, isGranted, type]);
    let load = React.useCallback(async () => {
        let filter: any = { type };
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (mode === 'd') {
            filter.created_at = { gte: getUnixTime(subDays(startOfDay(new Date), 30)) };
        } else if (mode === 'y') {
            filter.created_at = { gte: getUnixTime(subYears(startOfYear(new Date), 10)) };
        } else if (mode === 'w') {
            filter.created_at = { gte: getUnixTime(subDays(startOfWeek(new Date), 49)) };
        } else {
            filter.created_at = { gte: getUnixTime(subMonths(startOfMonth(new Date), 12)) };
        }
        let x: Record<string, true> = {}, max: Record<string, number> = {}, sum: Record<string, BigNumber> = {};
        let response = await getLogsStat({ group: mode, filter, timezone });
        if (typeof response !== 'string') {
            for (let i of response) {
                max[i.date] = Math.max(max[i.date] ?? 0, i.point);
                x[i.date] = true;
            }
        }
        if (user) {
            filter.user_id = parseInt(user);
        }
        let filtered = await getLogsStat({ group: mode, filter, timezone });
        if (typeof filtered !== 'string') {
            for (let i of filtered) {
                x[i.date] = true;
                sum[i.date] = (sum[i.date] ?? new BigNumber(0)).plus(i.point);
            }
            let config: any = { tooltip: { trigger: 'item' }, legend: { data: [__('Current'), __('Best')] }, yAxis: [{ type: 'value', position: 'left' }, { type: 'value', position: 'right' }], xAxis: { type: 'category', data: [] }, series: [{ type: 'bar', data: [], yAxisIndex: 0, name: __('Current') }, { type: 'bar', data: [], yAxisIndex: 0, name: __('Best') }] };
            if (!user) {
                config.legend = { data: [__('Total'), __('Best')] };
                config.series = [{ type: 'line', data: [], yAxisIndex: 1, name: __('Total') }, { type: 'bar', data: [], yAxisIndex: 0, name: __('Best') }];
            }
            let dates = Object.keys(x);
            dates.sort();
            dates.map(date => {
                config.xAxis.data.push(date);
                config.series[0].data.push(parseFloat((sum[date] ?? new BigNumber(0)).toFixed(1, BigNumber.ROUND_HALF_UP)));
                config.series[1].data.push(max[date] ?? 0);
            })
            setPoints(config);
        }
    }, [type, user, users, __, mode, setPoints]);
    React.useImperativeHandle(ref, () => load, [load]);
    React.useEffect(() => void load(), [load]);
    return (
        <>
            <MDBRow className="justify-content-between g-3">
                <MDBCol size="12" md="4" lg="3">
                    {isGranted('__admin_user__GET') ? (
                        <Select options={users} value={user} onChange={setUser}>
                            <option value="">{__('All')}</option>
                        </Select>
                    ) : null}
                </MDBCol>
                <MDBCol size="12" md="4" lg="3">
                    <Select value={mode} onChange={setMode} options={[
                        { value: 'd', label: __('Daily') },
                        { value: 'w', label: __('Weekly') },
                        { value: 'm', label: __('Monthly') },
                        { value: 'y', label: __('Annually‌') },
                    ]} />
                </MDBCol>
                <MDBCol size="12">
                    {points ? (
                        <EChartsReact
                            echarts={echarts}
                            option={points}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                    )}
                </MDBCol>
            </MDBRow>
        </>
    );
});

const Counts = React.forwardRef<() => void, { type: string }>(function ({ type }, ref) {
    let { 0: points, 1: setPoints } = React.useState<any>(null);
    let { 0: user, 1: setUser } = React.useState<string>('');
    let { 0: mode, 1: setMode } = React.useState<string>('m');
    let { 0: users, 1: setUsers } = React.useState<Array<OptionType>>([]);
    let { 0: __ } = useLocale();
    let { 0: isGranted } = useRbac();
    React.useEffect(() => {
        let permissions = type == '1' ? 'claimKPI' : (type == '2' ? 'setStockStatus' : undefined);
        isGranted('__admin_user__GET') && getUser({ filter: { status: { gte: 0 }, permissions }, limit: -1 } as any).then(response => {
            if (typeof response !== 'string') {
                let options = [];
                for (let item of response.data) {
                    options.push({ value: item.id.toString(), label: item.info?.nickname || item.username });
                }
                setUsers(options);
            }
        });
    }, [setUsers, isGranted, type]);
    let load = React.useCallback(async () => {
        let filter: any = { type, status: 1 };
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (mode === 'd') {
            filter.created_at = { gte: getUnixTime(subDays(startOfDay(new Date), 30)) };
        } else if (mode === 'y') {
            filter.created_at = { gte: getUnixTime(subYears(startOfYear(new Date), 10)) };
        } else if (mode === 'w') {
            filter.created_at = { gte: getUnixTime(subDays(startOfWeek(new Date), 49)) };
        } else {
            filter.created_at = { gte: getUnixTime(subMonths(startOfMonth(new Date), 12)) };
        }
        let x: Record<string, true> = {}, max: Record<string, number> = {}, sum: Record<string, BigNumber> = {};
        let response = await getLogsStat({ group: mode, filter, timezone });
        if (typeof response !== 'string') {
            for (let i of response) {
                max[i.date] = Math.max(max[i.date] ?? 0, i.qty);
                x[i.date] = true;
            }
        }
        if (user) {
            filter.user_id = parseInt(user);
        }
        let filtered = await getLogsStat({ group: mode, filter, timezone });
        if (typeof filtered !== 'string') {
            for (let i of filtered) {
                x[i.date] = true;
                sum[i.date] = (sum[i.date] ?? new BigNumber(0)).plus(i.qty);
            }
            let config: any = { tooltip: { trigger: 'item' }, legend: { data: [__('Current'), __('Best')] }, yAxis: [{ type: 'value', position: 'left' }, { type: 'value', position: 'right' }], xAxis: { type: 'category', data: [] }, series: [{ type: 'bar', data: [], yAxisIndex: 0, name: __('Current') }, { type: 'bar', data: [], yAxisIndex: 0, name: __('Best') }] };
            if (!user) {
                config.legend = { data: [__('Total'), __('Best')] };
                config.series = [{ type: 'line', data: [], yAxisIndex: 1, name: __('Total') }, { type: 'bar', data: [], yAxisIndex: 0, name: __('Best') }];
            }
            let dates = Object.keys(x);
            dates.sort();
            dates.map(date => {
                config.xAxis.data.push(date);
                config.series[0].data.push(parseFloat((sum[date] ?? new BigNumber(0)).toFixed(1, BigNumber.ROUND_HALF_UP)));
                config.series[1].data.push(max[date] ?? 0);
            })
            setPoints(config);
        }
    }, [type, user, users, __, mode, setPoints]);
    React.useImperativeHandle(ref, () => load, [load]);
    React.useEffect(() => void load(), [load]);
    return (
        <>
            <MDBRow className="justify-content-between g-3">
                <MDBCol size="12" md="4" lg="3">
                    {isGranted('__admin_user__GET') ? (
                        <Select options={users} value={user} onChange={setUser}>
                            <option value="">{__('All')}</option>
                        </Select>
                    ) : null}
                </MDBCol>
                <MDBCol size="12" md="4" lg="3">
                    <Select value={mode} onChange={setMode} options={[
                        { value: 'd', label: __('Daily') },
                        { value: 'w', label: __('Weekly') },
                        { value: 'm', label: __('Monthly') },
                        { value: 'y', label: __('Annually‌') },
                    ]} />
                </MDBCol>
                <MDBCol size="12">
                    {points ? (
                        <EChartsReact
                            echarts={echarts}
                            option={points}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                    )}
                </MDBCol>
            </MDBRow>
        </>
    );
});

const Sales = React.forwardRef<() => void>(function (_, ref) {
    let { 0: data, 1: setData } = React.useState<any>(null);
    let { 0: mode, 1: setMode } = React.useState<string>('m');
    let { 0: __ } = useLocale();
    let { 0: isGranted } = useRbac();
    let loadOrders = React.useCallback((force = false) => new Promise<Record<string, Required<StatData>>>((resolve, reject) => {
        if (isGranted('__sales_order_stat__GET')) {
            let filter: any = {};
            let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (mode === 'd') {
                filter.completed_at = { gte: getUnixTime(subDays(startOfDay(new Date), 30)) };
            } else if (mode === 'y') {
                filter.completed_at = { gte: getUnixTime(subDays(startOfYear(new Date), 10)) };
            } else {
                filter.completed_at = { gte: getUnixTime(subDays(startOfMonth(new Date), 12)) };
            }
            let result: Record<string, Required<StatData>> = {};
            statSalesOrders({ group: mode, filter, timezone }, force).then(response => {
                if (typeof response !== 'string') {
                    for (let i of response) {
                        result[i.date] = i;
                    }
                    resolve(result);
                } else {
                    reject();
                }
            }, reject);
        } else {
            reject();
        }
    }), [isGranted, mode]);
    let loadMemos = React.useCallback((force = false) => new Promise<Record<string, Required<StatData>>>((resolve, reject) => {
        if (isGranted('__credit_memo_stat__GET')) {
            let filter: any = {};
            let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (mode === 'd') {
                filter.created_at = { gte: getUnixTime(subDays(startOfDay(new Date), 30)) };
            } else if (mode === 'y') {
                filter.created_at = { gte: getUnixTime(subYears(startOfYear(new Date), 10)) };
            } else {
                filter.created_at = { gte: getUnixTime(subMonths(startOfMonth(new Date), 12)) };
            }
            let result: Record<string, Required<StatData>> = {};
            statCreditMemos({ group: mode, filter, timezone }, force).then(response => {
                if (typeof response !== 'string') {
                    for (let i of response) {
                        result[i.date] = i;
                    }
                    resolve(result);
                } else {
                    reject();
                }
            }, reject);
        } else {
            reject();
        }
    }), [isGranted, mode]);
    let load = React.useCallback((force = false) => {
        let config: any = { tooltip: { trigger: 'item' }, legend: { data: [__('Orders'), __('Credit Memos')] }, yAxis: [{ type: 'value', position: 'right' }, { type: 'value', axisLabel: { formatter: '${value}' } }], xAxis: { type: 'category', data: [] }, series: [{ type: 'bar', name: __('Orders'), yAxisIndex: 0, data: [] }, { type: 'bar', name: __('Credit Memos'), yAxisIndex: 0, data: [] }, { type: 'line', name: __('Orders'), yAxisIndex: 1, data: [] }, { type: 'line', name: __('Credit Memos'), yAxisIndex: 1, data: [] }] };
        Promise.allSettled([loadOrders(force), loadMemos(force)]).then(values => {
            let data = [
                values[0].status === 'fulfilled' ? values[0].value : {},
                values[1].status === 'fulfilled' ? values[1].value : {}
            ];
            config.xAxis.data = Array.from(new Set([...Object.keys(data[0]), ...Object.keys(data[1])]));
            config.xAxis.data.sort((a: string, b: string) => a > b ? 1 : -1);
            for (let key of (config.xAxis.data as Array<string>)) {
                config.series[0].data.push(data[0][key]?.count ?? 0);
                config.series[2].data.push(data[0][key]?.total ?? 0);
                config.series[1].data.push(data[1][key]?.count ?? 0);
                config.series[3].data.push(data[1][key]?.total ?? 0);
            }
            setData(config);
        });
    }, [setData, __, loadOrders, loadMemos]);
    React.useImperativeHandle(ref, () => load.bind(null, true), [load]);
    React.useEffect(load, [load]);
    return (
        <>
            <MDBRow className="justify-content-between g-3">
                <MDBCol size="12" md="4" lg="3">
                    <Select value={mode} onChange={setMode} options={[
                        { value: 'd', label: __('Daily') },
                        { value: 'm', label: __('Monthly') },
                        { value: 'y', label: __('Annually‌') },
                    ]} />
                </MDBCol>
                <MDBCol size="12">
                    {data ? (
                        <EChartsReact
                            echarts={echarts}
                            option={data}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                    )}
                </MDBCol>
            </MDBRow>
        </>
    );
});

const Claims = React.forwardRef<() => void, { type: string }>(function ({ type }, ref) {
    const { 0: points, 1: setPoints } = React.useState<any>(null);
    const { 0: user, 1: setUser } = React.useState<string>('');
    const { 0: mode, 1: setMode } = React.useState<string>('m');
    let { 0: users, 1: setUsers } = React.useState<Array<OptionType>>([]);
    let { 0: __ } = useLocale();
    let { 0: isGranted } = useRbac();
    React.useEffect(() => {
        let permissions = type == '1' ? 'claimKPI' : (type == '2' ? 'setStockStatus' : undefined);
        isGranted('__admin_user__GET') && getUser({ filter: { status: { gte: 0 }, permissions }, limit: -1 } as any).then(response => {
            if (typeof response !== 'string') {
                let options = [];
                for (let item of response.data) {
                    options.push({ value: item.id.toString(), label: item.info?.nickname || item.username });
                }
                setUsers(options);
            }
        });
    }, [setUsers, isGranted, type]);
    const load = React.useCallback(async () => {
        const filter: any = { type };
        if (user) {
            filter.user_id = parseInt(user);
        }
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (mode === 'd') {
            filter.created_at = { gte: getUnixTime(subDays(startOfDay(new Date), 30)) };
        } else if (mode === 'y') {
            filter.created_at = { gte: getUnixTime(subYears(startOfYear(new Date), 10)) };
        } else if (mode === 'w') {
            filter.created_at = { gte: getUnixTime(subDays(startOfWeek(new Date), 49)) };
        } else {
            filter.created_at = { gte: getUnixTime(subMonths(startOfMonth(new Date), 12)) };
        }
        const x: Record<string, true> = {}, max: Record<string, number> = {}, sum: Record<string, BigNumber> = {};
        const response = await getLogsStat({ group: mode, filter: { ...filter, status: 1 }, timezone });
        if (typeof response !== 'string') {
            for (const i of response) {
                max[i.date] = Math.max(max[i.date] ?? 0, i.qty);
                x[i.date] = true;
            }
        }
        const filtered = await getLogsStat({ group: mode, filter: { ...filter, remark: { like: '%Assemble Damage%' } }, timezone });
        if (typeof filtered !== 'string') {
            for (const i of filtered) {
                x[i.date] = true;
                sum[i.date] = (sum[i.date] ?? new BigNumber(0)).plus(i.qty);
            }
            const config: any = { tooltip: { trigger: 'item', valueFormatter: (value: any) => value + '%' }, legend: { data: [__('general.percent')] }, yAxis: { type: 'value', position: 'left' }, xAxis: { type: 'category', data: [] }, series: { type: 'bar', data: [], yAxisIndex: 0 } };
            const dates = Object.keys(x);
            dates.sort();
            dates.map(date => {
                config.xAxis.data.push(date);
                config.series.data.push({
                    name: date + ': ' + (sum[date] ?? new BigNumber(0)).toString() + '/' + max[date],
                    value: parseFloat((sum[date] ?? new BigNumber(0)).div(max[date]).times(100).toFixed(1, BigNumber.ROUND_HALF_UP))
                });
            })
            setPoints(config);
        }
    }, [type, user, users, __, mode, setPoints]);
    React.useImperativeHandle(ref, () => load, [load]);
    React.useEffect(() => void load(), [load]);
    return (
        <MDBRow className="justify-content-between g-3">
            <MDBCol size="12" md="4" lg="3">
                {isGranted('__admin_user__GET') ? (
                    <Select options={users} value={user} onChange={setUser}>
                        <option value="">{__('All')}</option>
                    </Select>
                ) : null}
            </MDBCol>
            <MDBCol size="12" md="4" lg="3">
                <Select value={mode} onChange={setMode} options={[
                    { value: 'd', label: __('Daily') },
                    { value: 'w', label: __('Weekly') },
                    { value: 'm', label: __('Monthly') },
                    { value: 'y', label: __('Annually‌') },
                ]} />
            </MDBCol>
            <MDBCol size="12">
                {points ? (
                    <EChartsReact
                        echarts={echarts}
                        option={points}
                    />
                ) : (
                    <FontAwesomeIcon icon={faSpinner} spin size="3x" className="d-block mx-auto" />
                )}
            </MDBCol>
        </MDBRow>
    );
});
